import Drawer from '@mui/material/Drawer'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import * as React from 'react'
import { create as createNiceModal, useModal } from '@ebay/nice-modal-react'
import styled from 'styled-components'
import { I18n, useClickOutsideDetector } from 'common'
import { breakpoints } from '../../../../../theme/breakpoints'
import CloseIcon from '@mui/icons-material/Close'
import { defaultTheme } from '../../../../../theme/index'
import { zIndex } from '../../../../../theme/zIndex'
import Packed from './Packed'
import Delivered from './Delivered'
import Ordered from './Ordered'
import Shipped from './Shipped'
import Unavailable from '../../Unavailable'
import { DdsDetail } from '../../../../../store/orderHistory/interfaces'

export interface IDdsDetail extends DdsDetail {
  shippingId: string
  shipmentNumber: number
}
export interface ITrackingHistoryModal {
  ddsDetail: IDdsDetail
  state?: number
}

const TrackingHistory = createNiceModal<ITrackingHistoryModal>(
  observer(({ state, ddsDetail }): ReactElement => {
    const modal = useModal()
    const onClose = () => modal.remove()
    const show = modal.visible
    const ref = React.useRef<HTMLInputElement>(null)

    useClickOutsideDetector([ref], show, onClose)

    return (
      <ResponsiveDrawer
        anchor="bottom"
        open={show}
        onClose={onClose}
        PaperProps={{
          square: false,
        }}
        style={{
          width: '800px',
        }}
      >
        <Container ref={ref} state={state}>
          <TitleHeader>
            {state === 4 ? (
              <I18n name="deliveryStatusUnavailable" />
            ) : (
              <I18n name="trackingShipment" />
            )}

            <StyledCloseIcon onClick={onClose} />
          </TitleHeader>
          {ddsDetail && ddsDetail.order ? (
            <>
              {state === 0 && <Ordered ddsDetail={ddsDetail} />}
              {state === 1 && <Packed ddsDetail={ddsDetail} />}
              {state === 2 && <Shipped ddsDetail={ddsDetail} />}
              {state === 3 && <Delivered ddsDetail={ddsDetail} />}
              {state === 4 && <Unavailable />}
            </>
          ) : (
            <OrderUnavailable>
              <I18n name="trackingInformationIsNotYetAvailable" />
            </OrderUnavailable>
          )}
        </Container>
      </ResponsiveDrawer>
    )
  })
)

export default TrackingHistory

const TitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-transform: capitalize;
  color: #050505;
  margin-bottom: 12px;

  @media screen and (min-width: ${breakpoints.laptop}px) {
    margin-left: 0px;
    font-size: 24px;
  }
`

const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
  margin-top: 5.5px;
`

const ResponsiveDrawer = styled(Drawer)`
  /* padding: 28px 32px 37px; */
`

interface ContainerProps {
  height?: string
  width?: string
  state?: number
}

const Container = styled.div<ContainerProps>`
  position: relative;
  background-color: ${defaultTheme.colors.componentsBackground};
  z-index: ${zIndex.modal};
  padding: 28px 32px;
  overflow-y: auto;
  border-radius: 8px 8px 0px 0px;
  height: ${(props) => (props.state === 4 ? '50vh' : '90vh')};

  @media screen and (min-width: ${breakpoints.laptop}px) {
    position: fixed;
    top: 0%;
    right: 0;
    border-radius: 0px;
    width: 358px;
    height: 100vh;
    padding: 35px 32px;
  }
`
const OrderUnavailable = styled.p`
  font-size: 18px;
  letter-spacing: 0px;
  margin: 23px 0px 0px 0px;
  padding: 12px 12px 12px 0px;
`
